/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatientDocument } from './PatientDocument';
import {
    PatientDocumentFromJSON,
    PatientDocumentFromJSONTyped,
    PatientDocumentToJSON,
} from './PatientDocument';

/**
 * 
 * @export
 * @interface ApprovePatientDocuments
 */
export interface ApprovePatientDocuments {
    /**
     * 
     * @type {boolean}
     * @memberof ApprovePatientDocuments
     */
    follow_up?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApprovePatientDocuments
     */
    message?: string;
    /**
     * 
     * @type {Array<PatientDocument>}
     * @memberof ApprovePatientDocuments
     */
    documents: Array<PatientDocument>;
    /**
     * Optional AppointmentConcern id. When set, the server appends a
     * shortened patient-facing booking deep link to the outgoing SMS,
     * and tags the push payload so taps from the push banner route
     * to the booking flow prefilled to this concern.
     * @type {string}
     * @memberof ApprovePatientDocuments
     */
    booking_concern_id?: string;
}

/**
 * Check if a given object implements the ApprovePatientDocuments interface.
 */
export function instanceOfApprovePatientDocuments(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documents" in value;

    return isInstance;
}

export function ApprovePatientDocumentsFromJSON(json: any): ApprovePatientDocuments {
    return ApprovePatientDocumentsFromJSONTyped(json, false);
}

export function ApprovePatientDocumentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovePatientDocuments {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'follow_up': !exists(json, 'follow_up') ? undefined : json['follow_up'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'documents': ((json['documents'] as Array<any>).map(PatientDocumentFromJSON)),
        'booking_concern_id': !exists(json, 'booking_concern_id') ? undefined : json['booking_concern_id'],
    };
}

export function ApprovePatientDocumentsToJSON(value?: ApprovePatientDocuments | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'follow_up': value.follow_up,
        'message': value.message,
        'documents': ((value.documents as Array<any>).map(PatientDocumentToJSON)),
        'booking_concern_id': value.booking_concern_id,
    };
}

